import { type BundleMachineGuard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether every product in the add to bag run has reported back.
 */
export const checkIfAllProductsReported: BundleMachineGuard = (guardArgs) => {
  const { queue, inFlight } = guardArgs.context.productAdds;

  return queue.length === 0 && inFlight.length === 0;
};
